import { axios, config, bus } from './index'
let timmerPing = 0
let global_msg_id = 1;

let funcBeforeOpen = [];
let isWsOpened = false;

window.config = config;

const CallBackFuncList = {};
const listenFuncList = {};
const userInfo = {
  encode_id: '',
  server: '',
  token: '',
}

//=============限制api频率
const needwait = (()=>{
  const apiCmdList = []
  const apiCmdLimit = 40//后台限制50，留10给高优先级api使用
  const apiCmdTimeLength = 10 * 1000;
  function needWait(){
    let now = new Date().getTime();
    if(apiCmdList.length < apiCmdLimit){
      apiCmdList.push(now)
      return false;
    }else{
      if(apiCmdList[0] + apiCmdTimeLength < now){
        apiCmdList.shift();
        apiCmdList.push(now);
        return false;
      }else{
        return apiCmdList[0] + apiCmdTimeLength - now;
      }
    }
  }
  return needWait;
})();
window.needwait = needwait;

const liveRoomStatus = {
  roomId:null,
}
let ws
const tryConnectTime0 = 10;
let tryConnectTime = tryConnectTime0;
function connect(){
  try{
    ws = new WebSocket(config.webSocket.url + "/dial");
  }catch(e){
    console.error('webSocket connect error');
    if(tryConnectTime > 0){
      setTimeout(connect,5 * 1000);
      tryConnectTime--;
    }
    
    return;
  }
  tryConnectTime = tryConnectTime0;
  
   
  ws.onopen = function(evt) {
    console.log("Connection open ...");
    isWsOpened = true;
    login(()=>{
      resetLiveRoom();
    });
    
    let funcObj = funcBeforeOpen.shift()
    while(funcObj){
      send(funcObj)
      funcObj = funcBeforeOpen.shift();
    }
    // ws.send("Hello WebSockets!");
  };
   
  ws.onmessage = function(evt) {
    console.log("Received Message: " + evt.data);
    getMsgFromServer(evt.data)
    // ws.close();
  };
  ws.onclose = function(evt) {
    isWsOpened = false;
    connect();
    console.log("Connection closed.");
  };
}
if(config.webSocket){
  connect();
}else{
  config.afterInit(connect)
}


function login(callback = ()=>{}){
  if(userInfo.encode_id){
    send({
      cmd:'/login',
      data:userInfo,
      callback
    })
  }else{
    callback();
  }
}
function resetLiveRoom(callback = ()=>{}){
  send({
    cmd:'/live/room/change',
    data:{
      room_id:liveRoomStatus.roomId,
      leave:!liveRoomStatus.roomId
    },
    callback
  })
  
}

//======================================
function send({cmd,data,callback = ()=>{}}){
  let waitTime = needwait();  
  switch(cmd){
    case '/login':
      for(let key in userInfo){
        userInfo[key] = data[key];
      }    
    break;
    case '/live/room/change':
      liveRoomStatus.roomId = data.leave?null:data.room_id
    break;
  }
  if(isWsOpened){
    if(!['/login','/heartbeat'].includes(cmd)){//登录和心跳包为最高优先级，不限制
      if(waitTime){
        bus.$emit('apiWaiting');
        console.log(waitTime)
        setTimeout(()=>{
          bus.$emit('apiEndWait');
          send({
            cmd,
            data,
            callback
          })
        },waitTime)
        return;
      }
    }
    
    let msg_id = global_msg_id++;
    if(callback && typeof callback == 'function'){
      CallBackFuncList[msg_id] = callback;
    }
    ws.send(JSON.stringify({
      "cmd": cmd,
      "msg_id": msg_id,
      "body": data || {}
    }));
  }else{
    funcBeforeOpen.push({
      cmd,
      data,
      callback
    })
  }  
}
function getMsgFromServer(res){
  if(typeof res == 'string'){
    try{
      res = JSON.parse(res);
    }catch(e){
      throw e
    }
  }
  if(res.msg_id){
    if(CallBackFuncList[res.msg_id]){
      CallBackFuncList[res.msg_id](res);
      delete CallBackFuncList[res.msg_id];
    }
  }else{
    if(listenFuncList[res.cmd]){
      for(let func of listenFuncList[res.cmd]){
        try{
          func(res.body);
        }catch(e){
          console.error(r)
        }
      }
    }
  }
}

function heartbeat() {
  let connect = false;
  send({
    cmd:"/heartbeat",
    callback:(res)=>{
      if(res.code == 0){
        connect = true;
        setTimeout(heartbeat,5 * 60 * 1000);
      }
      // console.log(123,res)
    }
  });
  setTimeout(()=>{
    if(!connect){
      // connect()
    }
  },10 * 1000)
}

heartbeat();
 

//==========================================
let socket = {}

socket.get = function(cmd,data){
  return new Promise(function(resolve, reject) {
    send({
      cmd,
      data,
      callback:(res)=>{
        if(res.code == 0){
          resolve(res.body);
        }else{
          reject(res);
        }
        console.log('getMsg',res)
      }
    });
  });  
}

socket.listen = function(cmd,callback){
  listenFuncList[cmd] = listenFuncList[cmd] || [];
  listenFuncList[cmd].push(callback);
}
socket.offListen = function(cmd,callback){
  if(listenFuncList[cmd]){
    listenFuncList[cmd] = listenFuncList[cmd].filter((func)=>{
      return !func == callback;
    })
  }
}









export default socket;
